import type { Id } from "@/lib/api"

/** What the Roadmap page keeps in the URL: the item whose panel is open. */
export type RoadmapSearch = { item?: Id<"roadmapItems"> }

/**
 * Whatever the URL says, a search the page can draw. An id is letters and
 * digits; anything else is dropped rather than sent to the server, which
 * would refuse it.
 */
export function parseRoadmapSearch(search: Record<string, unknown>): RoadmapSearch {
  const { item } = search
  if (typeof item !== "string" || !/^[a-z0-9]{8,64}$/i.test(item)) return {}
  return { item: item as Id<"roadmapItems"> }
}
